import * as React from 'react';
import { cn } from '@/shared/utils/cn';

type StarProps = {
  fillPct: number;
  size?: number;
  className?: string;
  title?: string;
};

export function GameCardUIStar({ fillPct, size = 80, className, title }: StarProps) {
  const pct = Math.max(0, Math.min(100, fillPct));
  const id = React.useId();
  const isActive = pct > 0;
  const fill = pct <= 0 ? 'var(--color-text-subtle)' : pct >= 100 ? 'currentColor' : `url(#${id})`;

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      aria-hidden='true'
      className={cn(
        'pointer-events-none inline-block transition-colors',
        isActive ? 'text-text' : 'text-text-subtle',
        className,
      )}
    >
      <title>{title}</title>
      <defs>
        <linearGradient id={id} x1='0%' y1='0%' x2='100%' y2='0%'>
          <stop offset={`${pct}%`} stopColor='currentColor' />
          <stop offset={`${pct}%`} stopColor='var(--color-text-subtle)' />
        </linearGradient>
      </defs>
      <path
        d='M12 2.5l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.9 6.1 21.5l1.2-6.5L2.5 9.4l6.6-.9L12 2.5z'
        fill={fill}
      />
    </svg>
  );
}
